import axios from "axios";
import config from "./config";

export const fetchApplications = () => {
  return axios.get("/users/applications", config);
};
